/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */
namespace dvs_ui {

   export class NrpNavigatorVmViewComponent {

      public bindings: any;
      public controller: any;
      public template: string;

      constructor() {
         this.bindings = {};
         this.controller = NrpNavigatorViewVmsController;
         this.template = `<nrp-vms-list [dvs-urn]="$ctrl.dvsUrn"
                                        [selected-nrp-key]="$ctrl.nrpKey"
                                        class="fill-parent dvs-nrp-navigator-view"></nrp-vms-list>`;
      }
   }

   class NrpNavigatorViewVmsController {
      static readonly $inject = [
         "$rootScope",
         "nrpNavigatorService"
      ];

      public nrpKey: string;

      public dvsUrn: string;

      constructor(private $rootScope: any,
                  private nrpNavigatorService: NrpNavigatorService) {
         const objectId: string = this.$rootScope._route.objectId;

         this.nrpKey = this.nrpNavigatorService.getNrpKey(objectId);
         this.dvsUrn = this.nrpNavigatorService.getDvsUrn(objectId);
      }
   }

   angular.module("com.vmware.vsphere.client.dvs")
         .component("nrpNavigatorVmsView", new NrpNavigatorVmViewComponent());
}